'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const react = require('@emotion/react');
const styleEncapsulation = require('@zapier/style-encapsulation');
const React = require('react');
const theme_Colors = require('../../../../theme/Colors.cjs.js');
require('../../../../theme/Shadows.cjs.js');
require('../../../../theme/Typography.cjs.js');
const theme_LegacyTypography = require('../../../../theme/LegacyTypography.cjs.js');
const theme_LegacyColorMap = require('../../../../theme/LegacyColorMap.cjs.js');
const components_display_Heading_Heading = require('../../../display/Heading/Heading.cjs.js');
require('../../../../utils/heading-level-context/HeadingLevelContext.cjs.js');
const components_display_Icon_Icon = require('../../../display/Icon/Icon.cjs.js');
const components_display_Tag_Tag = require('../../../display/Tag/Tag.cjs.js');
const components_display_Text_Text = require('../../../display/Text/Text.cjs.js');
require('../../SubscriptionForm/SubscriptionForm.cjs.js');
const components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer = require('../../SubscriptionForm/SubscriptionFormWithDisclaimer.cjs.js');
require('../../SubscriptionForm/DisclaimerText.cjs.js');
const components_layout_Grid_Grid = require('../../../layout/Grid/Grid.cjs.js');
const components_navigation_Button_Button = require('../../../navigation/Button/Button.cjs.js');
const components_marketing_Hero_utils = require('../utils.cjs.js');
const styleMixins_reset = require('../../../../style-mixins/reset.cjs.js');

const breakpoints = {
  tablet: 768,
  desktop: 1230
};
const SubscriptionFormStyles = {
  ctaContainer: react.css`
    ${styleMixins_reset.boxSizing};
    max-width: 350px;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      max-width: 470px;
      align-items: stretch;
      flex-direction: column;
    }
  `,
  ctaDisclaimer: react.css`
    ${styleMixins_reset.boxSizing};
    margin: 10px 0;
    text-align: left;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      margin: 10px 0;
    }
  `
};
const Styles = styleEncapsulation.labelStyles("HeroFeatures", {
  root: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${theme_Colors.Colors[theme_LegacyColorMap.LegacyColorMap[backgroundColor]]};
  `,
  mediaContent: react.css`
    ${styleMixins_reset.boxSizing};
    width: 100%;
    img {
      min-height: 341px;
      object-fit: cover;
    }
  `,
  content: react.css`
    ${styleMixins_reset.boxSizing};
    margin: 0 auto;
    padding: 20px;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      padding: 80px 0;
    }
    @media screen and (min-width: ${breakpoints.desktop}px) {
      padding: 85px 0;
    }
    max-width: 770px;
    display: flex;
    flex-direction: column;
    align-items: center;
  `,
  textContent: react.css`
    ${styleMixins_reset.boxSizing};
    margin: auto;
  `,
  labelContainer: react.css`
    ${styleMixins_reset.boxSizing};
    margin-bottom: 10px;
  `,
  heading: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.pageHeader4}
    color: ${theme_Colors.Colors[components_marketing_Hero_utils.mapBackgroundColorToV5TextColorName(backgroundColor)]};
    margin-bottom: 10px;
    text-align: center;

    @media screen and (min-width: ${breakpoints.tablet}px) {
      ${theme_LegacyTypography.LegacyTypography.pageHeader3}
    }
  `,
  description: (backgroundColor = "neutral100") => react.css`
    ${styleMixins_reset.boxSizing};
    ${theme_LegacyTypography.LegacyTypography.pageHeader9}
    color: ${theme_Colors.Colors[components_marketing_Hero_utils.mapBackgroundColorToV5HeadingColorName(backgroundColor)]};
    text-align: center;
    margin: 0 auto;
    max-width: 570px;
  `,
  ctaContainer: (isSubscriptionForm = false) => react.css`
    ${styleMixins_reset.boxSizing};
    margin-top: 30px;
    text-align: center;
    width: 100%;
    @media screen and (min-width: ${breakpoints.tablet}px) {
      margin-top: 40px;
    }
    ${isSubscriptionForm && styleEncapsulation.withModifier("subscription-form", SubscriptionFormStyles.ctaContainer)}
  `,
  ctaButtonWrapper: react.css`
    ${styleMixins_reset.boxSizing};
    margin: 0 auto;

    // Button should take up full width in mobile only;
    button,
    a {
      width: 100%;
    }

    @media screen and (min-width: ${breakpoints.tablet}px) {
      button,
      a {
        width: auto;
      }
    }
  `,
  ctaDisclaimer: (isSubscriptionForm = false) => react.css`
    ${styleMixins_reset.boxSizing};
    margin: 10px 0 0 0;
    text-align: center;
    ${isSubscriptionForm && styleEncapsulation.withModifier("subscription-form-disclaimer", SubscriptionFormStyles.ctaDisclaimer)}
  `
});
const HeroFeatures = ({ backgroundColor = "neutral100", ctaColor = "primary", isSubscriptionForm = false, subscriptionPlaceholder = "Email address", heading, description, ctaText, ctaHref, ctaTarget, ctaDisabled = false, ctaDisclaimer, onCtaClick, onCtaKeyDown, children, onSubscriptionFormSubmit, label, labelIcon, labelColor }) => {
  components_marketing_Hero_utils.validateZapierBackgroundAccessibility(backgroundColor, isSubscriptionForm, !!ctaDisclaimer);
  const getCtaComponent = () => {
    const sharedProps = {
      children: ctaText,
      href: !isSubscriptionForm ? ctaHref : void 0,
      onClick: onCtaClick,
      onKeyDown: onCtaKeyDown,
      size: isSubscriptionForm ? "medium" : "large",
      type: isSubscriptionForm ? "submit" : "button",
      "data-testid": "standard-hero-cta-button",
      target: ctaTarget,
      disabled: ctaDisabled
    };
    const color = components_marketing_Hero_utils.getSupportedCTAColor(ctaColor, backgroundColor);
    return react.jsx(components_navigation_Button_Button.Button, Object.assign({}, sharedProps, {
      // "primary-alt" no longer exists as of V8 and is now mapped to "primary"
      color: color === "primary-alt" ? "primary" : color
    }));
  };
  return react.jsx(
    "div",
    { css: Styles.root(backgroundColor), "data-background-color": backgroundColor, "data-zds": true },
    react.jsx("div", { css: Styles.mediaContent, "data-zds": true }, children),
    react.jsx(
      "div",
      { css: Styles.content, "data-zds": true },
      label && react.jsx(
        "div",
        { css: Styles.labelContainer, "data-zds": true },
        react.jsx(components_display_Tag_Tag.Tag, { variant: labelColor }, labelIcon ? react.jsx(
          components_layout_Grid_Grid.Grid,
          { alignItems: "center", columns: "auto max-content", gap: 5 },
          react.jsx(components_display_Icon_Icon.Icon, { name: labelIcon, size: 20 }),
          label
        ) : label)
      ),
      react.jsx(components_display_Heading_Heading.Heading, { css: Styles.heading(backgroundColor) }, heading),
      description && react.jsx("div", { css: Styles.description(backgroundColor), "data-zds": true }, description),
      ctaText && (ctaHref || onCtaClick || isSubscriptionForm) && react.jsx("div", { css: Styles.ctaContainer(isSubscriptionForm), "data-zds": true }, isSubscriptionForm ? react.jsx(components_marketing_SubscriptionForm_SubscriptionFormWithDisclaimer.SubscriptionFormWithDisclaimer, { placeholderText: subscriptionPlaceholder, onSubmit: onSubscriptionFormSubmit, renderButton: () => getCtaComponent(), disclaimerTextColor: backgroundColor === "neutral100" ? "primary" : "secondary" }) : react.jsx(
        React.Fragment,
        null,
        react.jsx("div", { css: Styles.ctaButtonWrapper, "data-zds": true }, getCtaComponent()),
        ctaDisclaimer && react.jsx(
          "div",
          { css: Styles.ctaDisclaimer(isSubscriptionForm), "data-zds": true },
          react.jsx(components_display_Text_Text.Text, { tag: "div", type: "Body1", color: components_marketing_Hero_utils.mapBackgroundColorToV5HeadingColorName(backgroundColor) }, ctaDisclaimer)
        )
      ))
    )
  );
};

exports.HeroFeatures = HeroFeatures;
//# sourceMappingURL=HeroFeatures.cjs.js.map
